import { render } from "./HistoryPanel.vue?vue&type=template&id=2da3f30f&scoped=true"
import script from "./HistoryPanel.vue?vue&type=script&lang=js"
export * from "./HistoryPanel.vue?vue&type=script&lang=js"

import "./HistoryPanel.vue?vue&type=style&index=0&id=2da3f30f&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2da3f30f"]])

export default __exports__